import axios from 'axios';
import { useState, useEffect } from 'react';
import { apiConstant } from '../../constant';
import lodash from 'lodash';
import { processAuditCheckSheet, productAuditCheckSheet } from './checklist';

const useGetData = (
  id: string | undefined,
  checkSheetType: string | undefined
) => {
  const [moduleData, setModuleData] = useState<any>({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const checkSheetdata: any = {
    c1: lodash.cloneDeep(processAuditCheckSheet),
    c2: lodash.cloneDeep(productAuditCheckSheet),
  };

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      axios
        .get(`/api/${apiConstant.checklistData}/${id}`)
        .then((res) => {
          setModuleData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    } else {
      setModuleData({
        // checkSheetType: checkSheetType,
        c1: lodash.cloneDeep(checkSheetdata.c1),
        c2: lodash.cloneDeep(checkSheetdata.c2),
      });
    }
  }, [checkSheetType]);

  return { moduleData, isLoading, error };
};

export default useGetData;
